// Substitui src/environments/environment.ts no build da imagem de prd (ver Dockerfile).
// production fica false de propósito: é o que a imagem de prd usava até 10/2026 (build sem --prod).
export const environment = {
  production: false,
  urlApi: 'https://portalapi.uboi.com.br/api/',
  urlUpload: 'https://portalapi.uboi.com.br/api/upload',
  diretorioAnexos: 'D:/GitRepositorio/Datapar.VisualRodopar/Portal.WR.WebApi/Resources/Files'
};
